import { STATUS_TYPES_CLASSNAMES } from '../../components/Status'

export const SETTINGS_TABS = [
  {
    key: '0',
    label: 'Profile'
  },
  {
    key: '2',
    label: 'Payment details'
  },
  {
    key: '3',
    label: 'Notifications'
  }
]
export const SETTINGS_STATUSES = {
  VERIFIED: 'verified',
  ACCOUNT_RESTRICTED: 'account_restricted',
  VERIFICATION_IN_PROGRESS: 'verification_in_progress'
} as const

export const SETTINGS_STATUSES_CLASSNAME = {
  [SETTINGS_STATUSES.VERIFIED]: STATUS_TYPES_CLASSNAMES.GREEN,
  [SETTINGS_STATUSES.ACCOUNT_RESTRICTED]: STATUS_TYPES_CLASSNAMES.RED,
  [SETTINGS_STATUSES.VERIFICATION_IN_PROGRESS]: STATUS_TYPES_CLASSNAMES.YELLOW
}
export const SETTINGS_STATUSES_TOOLTIP = {
  [SETTINGS_STATUSES.VERIFICATION_IN_PROGRESS]:
    'All requirements fulfilled. Moov is verifying the information through compliance checks.',
  [SETTINGS_STATUSES.VERIFIED]:
    'All requirements satisfied and verified. The capability is active and can be used in production.',
  [SETTINGS_STATUSES.ACCOUNT_RESTRICTED]:
    'Capability turned off. May be due to a Moov compliance action or disabled via API/Dashboard.'
}

export const SETTINGS_STATUSES_TOOLTIP_BANK_ACCOUNT = {
  [SETTINGS_STATUSES.VERIFICATION_IN_PROGRESS]:
    'External account was created or updated. Verification pending.',
  [SETTINGS_STATUSES.VERIFIED]:
    'External account passed KYB verification. Sending and receiving funds is available.',
  [SETTINGS_STATUSES.ACCOUNT_RESTRICTED]:
    'External account matched a sanctions list during watchlist screening. Sending and receiving funds is not available.'
}

export const SETTINGS_STATUSES_NAME = {
  [SETTINGS_STATUSES.VERIFICATION_IN_PROGRESS]: 'Verification in progress',
  [SETTINGS_STATUSES.VERIFIED]: 'Verified',
  [SETTINGS_STATUSES.ACCOUNT_RESTRICTED]: 'Account Restricted'
} as const
